export default __webpack_public_path__ + "static/E_61-a3a15012fe8416bb6de05938d95490c4.png";